import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';
import { StaffMemberFragment } from './StaffMemberFragment';

const StaffListQuery = graphql.persisted(
  "StaffListQuery",
  graphql(`
    query StaffListQuery($schoolId: ID!, $kind: [StaffKindEnum!], $state: StaffStateEnum) {
      school(id: $schoolId) {
        id
        slug
        staffMembers(kind: $kind, state: $state) {
          ...StaffMemberFragment
        }
      }
    }
  `, [StaffMemberFragment])
);

export { StaffListQuery };

type StaffKind = 'TEACHER' | 'AIDE' | 'ADMIN' | 'OTHER';
type StaffState = 'ACTIVE' | 'INACTIVE';

export function useStaffListQuery(
  schoolId: string | undefined,
  filters: { kind?: StaffKind[]; state?: StaffState } = {}
) {
  return useQuery(StaffListQuery, {
    variables: {
      schoolId: schoolId!,
      kind: filters.kind,
      state: filters.state,
    },
    skip: !schoolId,
    fetchPolicy: 'cache-and-network',
  });
}
